module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/48368b326f3104d353495aa5f1f76ef6.png";